
import Barcode from "../../../assets/outline/Barcode.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BarcodeIcon({ className, dataTestid = "BarcodeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Barcode data-testid={dataTestid} className={classes} {...rest} />
  );
}
